import script from "./live-monitoring.vue?vue&type=script&setup=true&lang=js"
export * from "./live-monitoring.vue?vue&type=script&setup=true&lang=js"

import "./live-monitoring.vue?vue&type=style&index=0&id=585ff52d&scoped=true&lang=css"

import exportComponent from "E:\\茂侨项目文件夹\\monitoring-platform\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-585ff52d"]])

export default __exports__